module.exports = __webpack_public_path__ + "img/grid-dots-right.6af6a1f2.svg";